const styles = {
  imageSection: {
    width: '40px',
    height: '40px'
  }
};

export default styles;
